import PropTypes from "prop-types";
import Definition from "../Definition";

const DefinitionListCard = ({ listContent }) => {
  return (
    <div className="definitions__list-card">
      <div className="definitions__list-card-body">
        {listContent?.map((definition, index) => {
          return (
            <div key={index}>
              <div className="definitions__body-heading-wrapper">
                <h3 className="definitions__section-heading">
                  {definition.heading}
                </h3>
              </div>
              {definition.content?.map((item, index) => {
                return <Definition key={`definition-${index}`} {...item} />;
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
};

DefinitionListCard.propTypes = {
  listContent: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.string,
      content: PropTypes.array,
    })
  ).isRequired,
};

export default DefinitionListCard;
